































































































import Vue from "vue";
import _ from "lodash";
import { datetimeFormat, emptyValue, enumI18nFormat, moneyFormat } from "@/utils/lang";
import { $constants } from "@/scripts/constants";
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapActions } = createNamespacedHelpers("config");

const ItemMapper = (plan = {}) => {
    return {
        planName: `(${_.get(plan, "setting.year", "")}) ${_.get(plan, "planName", "")}`,
        planVersion: _.get(plan, "planVersion", ""),
        classificationName: _.get(plan, "program.occupationInfo.classificationName", ""),
        occupationLevel: _.get(plan, "program.occupationInfo.occupationLevel", ""),
        occupationLevelName: enumI18nFormat("levelEnum", _.get(plan, "program.occupationInfo.occupationLevel")),
        certificateType: _.get(plan, "setting.certificateType"),
        certificateTypeName: enumI18nFormat("certificateTypeEnum", _.get(plan, "setting.certificateType")),
        occupationName: _.get(plan, "program.occupationInfo.occupationName", ""),
        registrationCount: _.get(plan, "registrationCount", "0"),
        trainingType: enumI18nFormat("trainTypeEnum", _.get(plan, "setting.trainingType")),
        enrollmentCount: _.get(plan, "setting.enrollmentCount", ""),
        expectedOpeningTime: emptyValue(datetimeFormat(_.get(plan, "setting.openClassAt"))),
        trainingLocation: emptyValue(_.get(plan, "setting.trainingLocation")),
        fee: moneyFormat(_.get(plan, "setting.fee", 0)),
        startTime: datetimeFormat(_.get(plan, "setting.startTime"), $constants.DATE_FMT),
        endTime: datetimeFormat(_.get(plan, "setting.endTime"), $constants.DATE_FMT)
    };
};

export default Vue.extend({
    name: "PlanBaseInfo",
    props: {
        plan: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters(["orgConfig"]),
        item() {
            return ItemMapper(this.plan);
        },
        trainingOccupationEnabled(): boolean {
            if (_.keys(this.orgConfig).length == 0) {
                return true;
            }
            return !!this.orgConfig["trainingOccupationEnabled"];
        }
    },
    methods: {
        ...mapActions(["getOrgConfig"])
    },
    async mounted() {
        await this.getOrgConfig();
    }
});
